import { createFileRoute } from "@tanstack/react-router"
import { PromptHubPageWrapper } from "./-PromptHubPage"

export const Route = createFileRoute("/tools/prompt-hub")({
  component: PromptHubPageWrapper,
})
